<div class="container-fluid-page">
  <div class=" profile_details">
    <div class="container-fluid page">
      <div class="d-flex page__box p-3 mt-2">&nbsp;&nbsp;Access Control</div>
      <div class=" profile_details">
        <div class="page__content shadow p-3">
          <mat-form-field style="width: 500px; position: relative; top: 15px;
          margin-left: 20px;">
            <mat-select placeholder="Admins :"(selectionChange)="getMenuAccessControl($event)">
              <mat-option *ngFor="let opt of accessDataList; let i = index" [value]="opt.userId">
                {{opt.name}}
              </mat-option>
            </mat-select>
             </mat-form-field>&nbsp;&nbsp;&nbsp;
              <div *ngIf="MenuList1.length === 0" class="textCls">
              <p>
                Please select an admin ID to see and change it's permissions
              </p>
              </div>
      
         
          <div *ngFor="let opt of menuList">
            <div><input type="checkbox" name="{{item.name}}"></div>
            <div><label>{{item.name}}</label></div>
          </div>
          
          <div *ngIf = userId>
            <div class="row">
              <div class="access" style="float: right; margin-top: 14px;margin-left: 21px;font-size: 18px !important;"><b>Access Granted</b></div> 

              <mat-list-item>
                <mat-checkbox style="float: right;font-size: 18px !important; margin-right: 84px;
                                        margin-top: -24px !important;" class="custom-frame" [(ngModel)]="masterSelected"
                  name="list_name" value="m1" (change)="checkUncheckAll($event)"><b>Select All</b></mat-checkbox>
              </mat-list-item>
            </div>
            <div class="row">
              <mat-list-item class="col-md-6" style="padding-left: 100px;" *ngFor="let item of MenuList1">
                <mat-checkbox class="custom-frame" [(ngModel)]="item.isSelected" name="list_name" value="{{item.name}}"
                  (change)="isAllSelected()">
                  {{item.viewValue}}</mat-checkbox>
              </mat-list-item>
            </div>
            <hr>
            <div class="button" style="float:right; margin-top:-10px!important;">
              <button mat-raised-button class="btn btncls" (click)="closeDialog()">Cancel</button>
              <button mat-raised-button class="btn btncls1" (click)="onSubmit()">Apply</button>
            </div>
          </div>

        </div>

       
      </div>
    </div>
  </div>

</div>
<!-- </div> -->
<style>
  ::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-background {
    background-color: #90b93d !important;
  }

  mat-checkbox {
    font-size: 17px !important;
  }
  .mat-checkbox-layout{
    margin-right: 84px;
  }
  ::ng-deep.mat-checkbox-frame {
    border-radius: 70% !important;
  }

  ::ng-deep.mat-checkbox-background {
    border-radius: 70% !important;
  }

  .btncls {
    width: 85px;
    margin-top: -9px;
    margin-right: 10px;
    color: white;
    background-color: #234a90;
  }
  .btncls1 {
    width: 85px;
     /* margin-top: -9px; */
    margin-right: 10px; 
    color: white;
    background-color: #234a90;
  }
</style>


<style>
  .page__content {
    min-height: calc(calc(111vh - 78px)) !important;
    border-radius: 10px;
    margin-top: -2rem;
    background: white;
    color: black;
    font-size: 2rem;
  }

  .container-fluid {
    height: 60%;
    /* margin-top: -1rem; */
  }
</style>